import {
  getAvatarFromIcon,
  getIcon,
} from "@app/components/resources/resources_icons";
import { DEFAULT_MCP_SERVER_ICON } from "@app/lib/actions/constants";
import type { MCPServerType } from "@app/lib/api/mcp";
import { imageOutil } from "@app/lib/compta/icones_outils";
import { Avatar, cn } from "@dust-tt/sparkle";
import type { ComponentProps, ComponentType } from "react";

export { DEFAULT_MCP_SERVER_ICON };

// Fork (02/10) : un serveur distant de marque (Outils Pirouette, Service public) s'affiche avec
// son image (front/lib/compta/icones_outils.ts) au lieu de l'icône fixe de l'amont.
type ServeurAffiche = Pick<MCPServerType, "icon"> & {
  name?: string | null;
  url?: string | null;
};

// MCP-specific function
export const getAvatar = (
  mcpServer: ServeurAffiche,
  size: ComponentProps<typeof Avatar>["size"] = "sm"
) => {
  const image = imageOutil(mcpServer);
  if (image) {
    return (
      <Avatar visual={image} size={size} name={mcpServer.name ?? undefined} />
    );
  }
  return getAvatarFromIcon(mcpServer.icon, size);
};

// Un composant par image, gardé : son identité reste stable d'un rendu à l'autre.
const COMPOSANTS_IMAGE = new Map<
  string,
  ComponentType<{ className?: string }>
>();

/** Composant d'icône affichant une image (même contrat que les icônes Sparkle). */
export function iconeImage(src: string): ComponentType<{ className?: string }> {
  let composant = COMPOSANTS_IMAGE.get(src);
  if (!composant) {
    const IconeDeMarque = ({ className }: { className?: string }) => (
      <img
        src={src}
        alt=""
        aria-hidden
        className={cn("object-contain", className)}
      />
    );
    composant = IconeDeMarque;
    COMPOSANTS_IMAGE.set(src, composant);
  }
  return composant;
}

/** Icône (composant) d'un serveur MCP, avec la surcharge de marque du fork. */
export function getServerIcon(
  mcpServer: ServeurAffiche
): ReturnType<typeof getIcon> {
  const image = imageOutil(mcpServer);
  return image ? iconeImage(image) : getIcon(mcpServer.icon);
}
